import React from 'react';
//import ReactToPdf from 'react-to-pdf';
import html2canvas from 'html2canvas';
import canvas2image from '@/utils/canvas2image';
import BaseClass from '@/pages/BaseClass';

import {CommonValue, httpPost, pcUrl,} from '@/utils/tools';
//import {jsPDF} from 'jspdf';

export default class App extends BaseClass {
    constructor(props) {
        super(props);
        this.state = {
            'courseId': 0,
            'userInfo': {},
            'info': {
                //报告名称
                'reportName': '',
                //研究背景
                'background': '',
                //研究目的
                'objective': '',
                //研究理论
                'theory': '',
                //研究过程
                'process': '',
                //研究结论
                'conclusion': '',
                //参考文献
                'reference': '',
            },
            'statusList': {
                '0': '草稿',
                '1': '等待审核',
                '2': '审核通过',
                '3': '审核不通过',
            },
        };
    }

    componentDidMount() {
        let courseId = this.props.match.params.id;
        if (!courseId)
            this.props.history.goBack();
        this.state.courseId = courseId;

        let userInfo = CommonValue.get('user_info');
        this.setState({
            userInfo
        });

        this.getInfo();
    }

    getInfo() {
        let url = pcUrl('/study/course/' + this.state.courseId + '/report');
        httpPost(url, {}, 'GET')
            .then(data => {
                this.setState({
                    'info': data,
                });
            });
    }

    download(type) {
        if ('report' == type) {
            //window.location = this.state.info.reportUrl;
            window.location = 'http://47.100.220.191:12080/profile/report/pdf/report_1656514933251219458.pdf';
        } else if ('certificate' == type) {
            window.location = this.state.info.certificateUrl;
        }
    }

    downloadImage() {
        html2canvas(this.previewRef, {
            'useCORS': true,
        })
            .then(canvas => {
                /*
                let dataUrl = canvas.toDataURL('image/png');
                let a = document.createElement('a');
                document.body.appendChild(a);
                a.href = URL.createObjectURL(base64ToBlob(dataUrl));
                a.click();
                */

                var context = canvas.getContext('2d')
                // 【重要】关闭抗锯齿
                context.mozImageSmoothingEnabled = false
                context.webkitImageSmoothingEnabled = false
                context.msImageSmoothingEnabled = false
                context.imageSmoothingEnabled = false

                var img = canvas2image.convertToPNG(canvas, canvas.width, canvas.height)
                let dataURL = img.getAttribute('src')

                // 下载图片
                let a = document.createElement('a')
                document.body.appendChild(a)
                a.href = img.src

                // 设置下载标题
                a.download = `${this.state.info.courseName}学习报告.png`
                a.click()
            });
    }

    render() {
        return (
            <>
                <div className="height-20"></div>
                <div className="body">
                    <div className="report-preview-panel">
                        <div className="captain">
                            <h3>{this.state.statusList[this.state.info.status]}</h3>
                            {this.state.info.reviewComment ? (
                                <h4>{this.state.info.reviewComment}</h4>
                            ) : ''}
                        </div>
                        <div className="panel-body">
                            <div className="report-preview">
                                <div className="report-preview-inner">
                                    <h4>{this.state.info.courseName}</h4>
                                    <div className="preview-inner">
                                        <div className="preview-inner-inner" ref={e => this.previewRef = e}>
                                            <div className="inner-title">
                                                {this.state.info.reportName}
                                            </div>
                                            <div className="inner-desc">
                                                <div className="row">
                                                    <div className="col-6">
                                                        <span>学生姓名：</span>
                                                        {this.state.userInfo.name}
                                                    </div>
                                                    <div className="col-6">
                                                        <span>导师姓名：</span>
                                                        {this.state.info.teacherName}
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-6">
                                                        <span>所在学校：</span>
                                                        {this.state.userInfo.schoolName}
                                                    </div>
                                                    <div className="col-6">
                                                        <span>导师学校：</span>
                                                        {this.state.info.teacherSchool}
                                                    </div>
                                                </div>
                                            </div>
                                            {this.state.info.background.length > 0 && (
                                                <div className="inner-panel">
                                                    <div className="inner-captain">
                                                        研究背景
                                                    </div>
                                                    <div className="inner-body"
                                                         dangerouslySetInnerHTML={{'__html': this.state.info.background}}></div>
                                                </div>
                                            )}
                                            {this.state.info.objective.length > 0 && (
                                                <div className="inner-panel">
                                                    <div className="inner-captain">
                                                        研究目的
                                                    </div>
                                                    <div className="inner-body"
                                                         dangerouslySetInnerHTML={{'__html': this.state.info.objective}}></div>
                                                </div>
                                            )}
                                            {this.state.info.theory.length > 0 && (
                                                <div className="inner-panel">
                                                    <div className="inner-captain">
                                                        研究理论
                                                    </div>
                                                    <div className="inner-body"
                                                         dangerouslySetInnerHTML={{'__html': this.state.info.theory}}></div>
                                                </div>
                                            )}
                                            {this.state.info.process.length > 0 && (
                                                <div className="inner-panel">
                                                    <div className="inner-captain">
                                                        研究过程
                                                    </div>
                                                    <div className="inner-body"
                                                         dangerouslySetInnerHTML={{'__html': this.state.info.process}}></div>
                                                </div>
                                            )}
                                            {this.state.info.conclusion.length > 0 && (
                                                <div className="inner-panel">
                                                    <div className="inner-captain">
                                                        研究结论
                                                    </div>
                                                    <div className="inner-body"
                                                         dangerouslySetInnerHTML={{'__html': this.state.info.conclusion}}></div>
                                                </div>
                                            )}
                                            {this.state.info.reference.length > 0 && (
                                                <div className="inner-panel">
                                                    <div className="inner-captain">
                                                        参考文献
                                                    </div>
                                                    <div className="inner-body"
                                                         dangerouslySetInnerHTML={{'__html': this.state.info.reference}}></div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div className="height-25"></div>
                                <div className="text-right">
                                    {/*
										<ReactToPdf targetRef={this.previewRef} filename="div-blue.pdf" scale="2">
											{({toPdf}) => (
											<button className="button button-border border-blue1" onClick={toPdf}>
												<span className="clips download-ico"></span>
												&nbsp;
												下载报告
											</button>
											)}
										</ReactToPdf>
									*/}
                                    {this.state.info.reportUrl ? (
                                        <>
                                            <a href={this.state.info.reportUrl} target="_blank"
                                               className="button button-border border-blue1">
                                                <span className="clips download-ico"></span>
                                                &nbsp;
                                                下载报告
                                            </a>
                                            &nbsp;&nbsp;
                                        </>
                                    ) : ''}
                                    {this.state.info.certificateUrl ? (
                                        <>
                                            <a href={this.state.info.certificateUrl} target="_blank"
                                               className="button button-border border-blue1">
                                                <span className="clips download-ico"></span>
                                                &nbsp;
                                                下载证书
                                            </a>
                                            &nbsp;&nbsp;
                                        </>
                                    ) : ''}
                                    {this.state.info.status == 3 && (
                                        <button className="button button-border border-green"
                                                onClick={() => this.props.history.push(`/report1/${this.state.courseId}?id=${this.state.info.id}`)}>
                                            <span className="clips edit-ico"></span>
                                            &nbsp;
                                            修改报告
                                        </button>
                                    )}
                                </div>
                                <div className="padding-30"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="height-20"></div>
            </>
        );
    }
}

